import React, {useEffect, useState} from 'react';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import useFormApi from '../../../view/cmn/docAutomation/useFormApi'
import CheckSignStatus from '../../user/CheckSignStatus';
import SarasAppBar from '../../../library/container/appBar/SarasAppBar';
import SarasTrans from '../../../library/notifications/SarasTrans';
import SarasIconButton from '../../../library/input/buttons/iconButton/SarasIconButton';
import UserCulture from '../../user/components/UserCulture';
import CompanySwitcher from '../../user/components/CompanySwitcher';
import UserNavigation from '../../user/components/UserNavigation';
import useSarasStore from '../../../library/hooks/localDB/useSarasStore'
import SarasPopup from '../../../library/container/popup/SarasPopup';
import logots from '../../../logo/app_typescript.svg';
import AppMenu from './AppMenu';
import ShortcutMenu from './ShortcutMenu';
import UserManual from '../../user/components/UserManual';
import MobileApp from '../../user/components/MobileApp';
import { ROOT_ROUTE, HOME_ROUTE } from '../../main/routeTypes';
import * as fn from "../../../helper/uiFunctions";
import { ExploreIcon, SarasAppsIcon } from '../../../library/decor/SarasIcons';
import { changeTourAvailability } from '../../user/store/actions/action';
import { useDispatch } from 'react-redux';
import UserMessages from '../../user/components/UserMessages';

const PageHeader = ({currentPath, deviceInfo})=> {
  const [isMenuAvailable, setIsMenuAvailable] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  //0 is not loading, 1 is loading, 2 is loaded
  const [newDBLoading, setNewDBLoading] = useState(0);
  
  const [newMenuLoaded, setNewMenuLoaded] = useState(0);
  const [newLocaleLoaded, setNewLocaleLoaded] = useState(0);
  const [popupName, setPopupName] = useState("");
  const isSignedIn = useSelector(state => state.auth.isSignedIn);
  const serverAttributes = useSelector(state => state.auth.server);
  const isTourAvailable = useSelector(state => state.tourState.isTourAvailable);

  const history = useHistory();
  const formApi = useFormApi();
  const localDb = useSarasStore();

  const frbRef = React.useRef(null);
  const ipkRef = React.useRef(null);
  const dmRef = React.useRef(null);
  const debugRef = React.useRef(null);
  const maRef = React.useRef(null);
  const menuRef = React.useRef(null);
  const dispatchTourState = useDispatch();

  const checkIfUDKChanged = () => {
    if(newDBLoading === 0 && isSignedIn){
      localDb.getUDBKey(onLocalUDBKeySuccess);
    }

    if(newMenuLoaded === 1 && newLocaleLoaded === 1 && newDBLoading === 2){
      setNewDBLoading(0);
      setNewMenuLoaded(0);
      setNewLocaleLoaded(0);
      fn.reloadWindow(false);
    }
  };

  useEffect(checkIfUDKChanged, [serverAttributes, isSignedIn, newDBLoading, newMenuLoaded, newLocaleLoaded]);

  const onLocalUDBKeySuccess = (key, result) =>  {
    // console.log("checking app UDB key change 1", result, serverAttributes.UniqueDBKey);
      if(result !== serverAttributes.UniqueDBKey
        && serverAttributes.UniqueDBKey
        && newDBLoading === 0
        && isSignedIn) {
    
          // console.log("checking app UDB key change 2", result, serverAttributes.UniqueDBKey);
        setNewDBLoading(1);
        onUDBKeyChanged();
      }
  }

  const checkIfMenuRequired = () => {
    if(!isMenuAvailable && isSignedIn) {
      localDb.getAppMenu(onLocalMenuSuccess);
    }
  };

  useEffect(checkIfMenuRequired, [isMenuAvailable, isSignedIn]);

  const onUDBKeyChanged = () => {
    // alert("version changed");
    // if(history.location.pathname !== SIGN_OUT_ROUTE){
    //   history.push(SIGN_OUT_ROUTE);
    // }

    //reload menu and language translation data
    let menuAction = { actionId: "get", actionName: "menu", actionParam: {'content-type':'app-menu'}, containerKey:""};
    formApi.runGenericAction(menuAction, "menu", null, null, null, "", "", 0, onMenuSuccess);

    localDb.requestData("my_culture", (key, value) => {
      let localAction = { actionId: "get", actionName: "userData", actionParam: {'content-type':'app-locale', 'culture': value.toLowerCase()}, containerKey:""};
      formApi.runGenericAction(localAction, "userData", null, null, null, "", "", 0, onLocaleSuccess);
    });
    
    // console.log("app UDB key changed, updating local db", serverAttributes.UniqueDBKey);
    localDb.setUDBKey(serverAttributes.UniqueDBKey, onSaveUDBKey);
  }

  const onSaveUDBKey = () => {
      setNewDBLoading(2);
  }

  const onLocaleSuccess = (action, containerKey, rowKey, headerKey, response) => {
      if(response && response.dataList 
          && response.dataList.locale){

              const locale = response.dataList.locale;
      
              const jLocale = JSON.parse(locale);
              
              localDb.setData("downloaded_culture", jLocale.language);
              localDb.setStrings(jLocale.strings, 1, onLocaleSaved);
          }
    }
      
  const onLocaleSaved = () => {
    setNewLocaleLoaded(1);
  }

  const onLocalMenuSuccess = (key, value) =>  {
    if(value && typeof value != "string"){
      setIsMenuAvailable(true);
    }
    else{
      let menuAction = { actionId: "get", actionName: "menu", actionParam: {'content-type':'app-menu'}, containerKey:""};
      formApi.runGenericAction(menuAction, "menu", null, null, null, "", "", 0, onMenuSuccess);
    }
}

const onMenuSuccess = (action, containerKey, rowKey, headerKey, response) => {
    if(response.dataList && response.dataList.menu){
      const menusSerialised = response.dataList.menu;

      if(menusSerialised){
        setIsMenuAvailable(true);
        localDb.setAppMenu(JSON.parse(menusSerialised), onNewMenuSaved);
      }

      //goto default link but only when there is no other active link
      if(response.dataList.defaultLink && 
      (history.location.pathname === "" 
      || history.location.pathname === ROOT_ROUTE
      || history.location.pathname === HOME_ROUTE))
      {
        history.push(response.dataList.defaultLink);
      }
    }
  }

  const onNewMenuSaved = () => {
    setNewMenuLoaded(1);
  }

  const onTourOpenClick = () => {
      //default to -1, so that tour is not activated
      dispatchTourState(changeTourAvailability(-1, 1));
  }

  const handleAppMenuOpen = () => {
    setIsMenuOpen(true);
  };

  const handleAppMenuClose = () => {
    setIsMenuOpen(false);
  };

  const showHidePopup = (popupKey) => {
    setPopupName(popupKey);
  }

  const renderPopup = () => {
    let popupRef = null;
    let popupData = null;

    if (popupName === "MaintenanceModeFlag"){
      popupRef = maRef;
      popupData = serverAttributes.MaintenanceModeDescription;
    }
    else if (popupName === "DebugModeFlag"){
      popupRef = debugRef;
      popupData = serverAttributes.DebugModeFlagDescription;
    }
    else if (popupName === "DeveloperModeFlag"){
      popupRef = dmRef;
      popupData = serverAttributes.DeveloperModeFlagDescription;
    }
    else if (popupName === "InvalidPrivateKeyFlag"){
      popupRef = ipkRef;
      popupData = serverAttributes.InvalidPrivateKeyFlagDescription;
    }
    else if (popupName === "ForceRollbackFlag"){
      popupRef = frbRef;
      popupData = serverAttributes.ForceRollbackFlagDescription;
    }

    if(popupData){
      return (
        <SarasPopup anchorRef={popupRef} open={true}>
            <div className="uiBox" style={{maxWidth:"300px"}}>
                <ul>
                  {
                    Object.values(popupData).map((row, index)=>(
                        <li style={{listStyle:"disk", listStylePosition:"inside"}} key={index}>
                            {row}
                        </li>
                    ))
                  }
                </ul>
            </div>
        </SarasPopup>
      )
    }

    return null;
  }

  const renderMAMode = () => {
      return (
        <>
          {serverAttributes.ForceRollbackFlag === 1 ? 
            <div 
              ref={frbRef}
              className='uiAppWarningTag'
              onMouseEnter={() => {showHidePopup("ForceRollbackFlag")}}
              onMouseLeave={() => {showHidePopup("")}}
              >
                <SarasTrans trKey="ForceRollbackFlag" />
            </div>
          : null}
          {serverAttributes.InvalidPrivateKeyFlag === 1 ? 
            <div 
              ref={ipkRef}
              className='uiAppWarningTag'
              onMouseEnter={() => {showHidePopup("InvalidPrivateKeyFlag")}}
              onMouseLeave={() => {showHidePopup("")}}
              >
                <SarasTrans trKey="InvalidPrivateKeyFlag" />
            </div>
          : null}
          {serverAttributes.DeveloperModeFlag === 1 ? 
            <div 
              ref={dmRef}
              className='uiAppWarningTag'
              onMouseEnter={() => {showHidePopup("DeveloperModeFlag")}}
              onMouseLeave={() => {showHidePopup("")}}
              >
                <SarasTrans trKey="DeveloperModeFlag" />
            </div> 
          : null}
          {serverAttributes.DebugModeFlag === 1 ? 
            <div 
              ref={debugRef}
              className='uiAppWarningTag'
              onMouseEnter={() => {showHidePopup("DebugModeFlag")}}
              onMouseLeave={() => {showHidePopup("")}}
              >
                <SarasTrans trKey="DebugModeFlag" />
            </div> 
          : null}
          {serverAttributes.MaintenanceModeFlag === 1 ? 
            <div 
              ref={maRef}
              className='uiAppWarningTag'
              onMouseEnter={() => {showHidePopup("MaintenanceModeFlag")}}
              onMouseLeave={() => {showHidePopup("")}}
              >
                <SarasTrans trKey="MaintenanceModeFlag" />
            </div> 
          : null}

          {serverAttributes.ProfileName && !deviceInfo.activateMobileView ?
            <span className='uiAppIconWithTitle'>
                <div className={`uiServerProfile uiAppIcon uiSP${serverAttributes.ProfileName}`}>
                    <div className="uiSPInd"></div>
                </div>
                <span><SarasTrans value={`${serverAttributes.ProfileName} App`} /></span>
            </span>
          : null
          }
          {renderPopup()}
        </>
      );
  }
  
  return (
    <>
      <SarasAppBar position="fixed" style={{ zIndex:'1201' }} className="uiAppHeader" toolbarClass="uiAppToolBar">
          <div ref={menuRef} className=''>
            <SarasIconButton
              color="inherit"
              aria-label="SarasX menu"
              className="uiAppMenuIcon"
              onclick={isMenuOpen ? handleAppMenuClose : handleAppMenuOpen}
              edge="start"
            >
              <SarasAppsIcon className='uiAppIcon saras-tour-home-main-menu' style={{fontSize:25}}/>
              <img src={logots} height={18} alt="logo" className='uiAppMenuLogo' />
            </SarasIconButton>
          </div>
          {deviceInfo.activateMobileView && <ShortcutMenu />}
          <div className='uiAppRightMenu saras-tour-home-top-menu'>
            {!deviceInfo.activateMobileView && renderMAMode()}
            {isTourAvailable === 1 ?
              <span className='uiAppIconWithLink' onClick={onTourOpenClick}>
                  <ExploreIcon className='uiAppIcon'/>
                  {!deviceInfo.activateMobileView && <span><SarasTrans value="What's New!" /></span>}
              </span> : null }
            <UserManual deviceInfo={deviceInfo}/>
            <MobileApp deviceInfo={deviceInfo} mobileAppActive = {serverAttributes.MobileAppActive}/>
            <UserCulture deviceInfo={deviceInfo}/>
            <CompanySwitcher currentPath = {currentPath} deviceInfo={deviceInfo}/>
            <UserMessages deviceInfo={deviceInfo}/>
            <UserNavigation deviceInfo={deviceInfo}/>
            <CheckSignStatus />
          </div>
      </SarasAppBar>
      <AppMenu anchorRef={menuRef} isMenuOpen={isMenuOpen} onClose={handleAppMenuClose} />
    </>
  );
}

export default PageHeader
